module.exports = "<happy-input-template [controlName]=\"formControlName\" [form]=\"form\" [required]=\"required\">\n    <ng-content select=[input-group-label] input-label></ng-content>\n    <ng-content select=[input-guidance] input-guidance></ng-content>\n    <div input-control class=\"checkbox-group\">\n        <input [formControlName]=\"formControlName\" type=\"checkbox\" [id]=\"id\">\n        <ng-content select=[input-label]></ng-content>\n    </div>\n</happy-input-template>"


//////////////////
// WEBPACK FOOTER
// ./src/app/shared/components/happy/happy-checkbox-control/happy-checkbox-control.component.html
// module id = 956
// module chunks = 0